const charactersLimit = 11;

module.exports = function () {
    return function (input) {
        return input && input.length > charactersLimit
            ? 'Hello'
            : `Hi ${input}`;
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/wow-username-limiter.js
 **/